













import PopupCircleTemplate from '@/views/templates/africadogs/PopupCircleTemplate.vue'

export default
  components: {
    PopupCircleTemplate
  }

  props:
    title:
      type: Array
      default: []
    subtitle:
      type: Array
      default: []
    message:
      type: Array
      default: []
    point:
      type: String
    main_image:
      type: String
    mode_simple:
      type: Boolean
      default: false

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    addPoint: (point) ->
      @$emit('addPoint', point)
  }
